import { render } from "./MovesWidget.vue?vue&type=template&id=597f8e48&scoped=true"
import script from "./MovesWidget.vue?vue&type=script&lang=js"
export * from "./MovesWidget.vue?vue&type=script&lang=js"

import "./MovesWidget.vue?vue&type=style&index=0&id=597f8e48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597f8e48"]])

export default __exports__